{
  "name": "invert-strobe",
  "doc": "A partial inversion every pass: the history alternates light and dark as it recedes, like a negative that keeps flipping. Short decay so it never greys out. The most violent preset.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.016,
  "zoomexp": 1.0,
  "rot": 0.006,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.93,
  "invert": 0.12,
  "hueShift": 0.01,
  "darkenCenter": 0.5,
  "wave": "LINE",
  "waveColor": 1,
  "shapes": 0,
  "energy": [
    0.75,
    1.0
  ]
}